import React, { Component, Fragment } from 'react';
import 'styled-components/macro'
import styled from 'styled-components'

const JokeContainer = styled.div`
    margin-top: 4rem;
    margin-bottom: 2rem;
    text-align: center;
    background-color: white;
    padding: 4rem 2rem;
    border-radius: 0.4rem;
` 

const JokeText = styled.p`
    font-size: 2rem;
    color: inherit;
`

class Joke extends Component {
    renderJoke = () => {
        const { isPending, value } = this.props.joke
        return (
            <JokeContainer>
                <JokeText>
                    {isPending ? 'Loading...' : value }
                </JokeText>
            </JokeContainer>
        )
    }

    render() { 
        return (
            <Fragment>
                {this.renderJoke()}
            </Fragment>
        )
    }
}

 
export default Joke